import { userAPI } from '@/services-ts/axios'
import type {
  IGetBorderedEmployeeList,
  IGetEmployeeList,
  IGetEmployeeListByFilter,
  IPayloadEmployee,
  IPayloadEmployeeBorders,
} from '@/types/Request'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useEmployeeStore = defineStore('employee', {
  actions: {
    async GetEmployeeList(payload: IGetEmployeeList) {
      const { status, data } = await userAPI.EmployeeServices.GetEmployeeList(payload)
      return status ? data : []
    },

    async CreateEmployee(payload: IPayloadEmployee) {
      const { status } = await userAPI.EmployeeServices.CreateEmployee(payload)
      if (status) {
        void Alert({
          type: 'success',
          message: Format('admin_global_success'),
        })
      }
      return status
    },

    async UpdateEmployee(payload: IPayloadEmployee) {
      const { status } = await userAPI.EmployeeServices.UpdateEmployee(payload)
      if (status) {
        void Alert({
          type: 'success',
          message: Format('admin_global_updated'),
        })
      }
      return status
    },

    async DeleteEmployee(Id: string) {
      const { status } = await userAPI.EmployeeServices.DeleteEmployee(Id)
      if (status) {
        void Alert({
          type: 'success',
          message: Format('admin_global_deleted'),
        })
      }
    },

    async AnonymizeEmployee(EmployeeId: string) {
      const { status } = await userAPI.EmployeeServices.AnonymizeEmployee(EmployeeId)
      if (status) {
        void Alert({
          type: 'success',
          message: Format('admin_global_success'),
        })
      }
    },

    async GetEmployeeListByFilter(payload: IGetEmployeeListByFilter) {
      const { data, status } = await userAPI.EmployeeServices.GetEmployeeListByFilter(payload)
      return status ? data : []
    },

    async GetEmployeeBorderList(payload: IGetBorderedEmployeeList) {
      const { data, status } = await userAPI.EmployeeServices.GetBorderedEmployeeList(payload)
      return status ? data : []
    },

    async UpdateEmployeeBorders(payload: IPayloadEmployeeBorders) {
      const { status } = await userAPI.EmployeeServices.UpdateEmployeeBorders(payload)
      if (status) {
        void Alert({
          type: 'success',
          message: Format('admin_global_success'),
        })
      }
      return status
    },
  },
})
